import React from 'react'
import { useDrop } from 'react-dnd'

const TileDropZone = ({ index, onReorder, onAddNew }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'practice-tile',
    drop: (item) => {
      if (item.tileId) {
        // Existing tile being reordered
        onReorder(item.tileId, index)
      } else if (item.tileType && onAddNew) {
        // New tile from palette
        onAddNew(item.tileType, index)
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver()
    })
  }), [index, onReorder, onAddNew])

  return (
    <div
      ref={drop}
      className={`transition-all ${
        isOver 
          ? 'bg-blue-400 h-6 border-2 border-blue-500 border-dashed rounded' 
          : 'bg-transparent h-2 hover:bg-gray-200'
      }`}
    />
  )
}

export default TileDropZone

